import { VdsCheckbox } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback } from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';
import styles from './CasFormCheckbox.module.scss';
import Field from '../field/Field';

interface CasFormCheckboxProps<TFormValues extends FieldValues>
  extends UseControllerProps<TFormValues> {
  label: string;
  isReadonly?: boolean;
  isRequired?: boolean;
}

export const CasFormCheckbox = <TFormValues extends FieldValues>(
  props: CasFormCheckboxProps<TFormValues>,
): ReactElement => {
  const { disabled, label, isReadonly, isRequired, ...sanitisedProps } = props;
  const { field, fieldState, formState } = useController(sanitisedProps);

  const onCheckboxChange = useCallback(() => {
    field.onChange(!field.value);
  }, [field]);

  const isError = !(disabled || field.disabled) && fieldState.error !== undefined;
  const errorMessage = isError ? fieldState.error?.message : undefined;
  const isDisabled = disabled || field.disabled || formState.isSubmitting;

  return (
    <Field
      key={field.name}
      uid={field.name}
      label={''}
      errorMessage={errorMessage}
      isDisabled={isDisabled}
    >
      {/* VDS Note: Unaltered, the VdsField causes the checkbox to be center-aligned without filling the width of the field. */}
      <div className={styles.vdsWorkaround}>
        <VdsCheckbox
          id={field.name}
          labelValue={label}
          size="medium"
          checked={field.value}
          onCheckboxChange={onCheckboxChange}
          // There is no readonly state for the VdsCheckbox, so disable it instead.
          disabled={isDisabled || isReadonly}
          error={isError}
          onBlur={field.onBlur}
          isRequired={isRequired}
        />
      </div>
    </Field>
  );
};

export default CasFormCheckbox;
